import { Injectable } from '@angular/core';
import { ApiClass } from '@data/class/api-class';
import { environment } from '@env/environment';
import { PendingBalancesResponse } from '@data/interfaces/pending-balances.interface';
import { MonthlyLeaseBalancesResponse } from '../../interfaces/monthly-balances.interface';

@Injectable({
  providedIn: 'root'
})
export class ApiDashboardService extends ApiClass {

  constructor() {
    super();
    this.path = 'dashboard';
  }

  getWalletAmount() {
    return this.http.get<{ data: any }>(`${environment.apiUrl}${this.path}/wallet-amount`, {})
  }

  getResiduary() {
    return this.http.get<{ data: any }>(`${environment.apiUrl}${this.path}/residuary`, {})
  }

  getClientsOverdue() {
    return this.http.get<{ data: any }>(`${environment.apiUrl}${this.path}/clients-overdue`, {})
  }

  getMonthlyTarget() {
    return this.http.get<{ data: any }>(`${environment.apiUrl}${this.path}/monthly-target`, {})
  }

  getAssets() {
    return this.http.get<{ data: any }>(`${environment.apiUrl}${this.path}/assets`, {})
  }

  getNewLeases() {
    return this.http.get<{ data: any }>(`${environment.apiUrl}${this.path}/new-leases`, {})
  }

  getPendingBalances() {
    return this.http.get<{ data: PendingBalancesResponse }>(`${environment.apiUrl}${this.path}/pending-balances`, {})
  }

  getMonthlyLeaseBalances() {
    return this.http.get<{ data: MonthlyLeaseBalancesResponse }>(`${environment.apiUrl}${this.path}/monthly-lease-balances`, {})
  }
}
